import { defineMessages } from 'react-intl';

export default defineMessages({
    backToSignIn: {
        id: 'auth.components.common.AuthConfirmationMessage.Back to Sign In',
        defaultMessage: 'Back to Sign In'
    },
});
